<template>
  <transition>
    <el-backtop  :right="40" :bottom="100" title="返回顶部">
      <div class="backTop">
        <span class="icon iconfont" style="font-size: 20px">&#xe795;</span>
      </div>
    </el-backtop>
  </transition>
</template>

<script>
  export default {
    name: 'BackToTop',
  }
</script>

<style scoped>
   .backTop{
     height: 100%;
     width: 100%;
     background-color: #f2f5f6;
     box-shadow: 0 0 6px rgba(0,0,0, .12);
     text-align: center;
     line-height: 40px;
     color: #17b3a3;
   }

   .backTop:hover{
     background-color: #e7f6ff;
     color: #ff6c1d;
   }
</style>



// WEBPACK FOOTER //
// src/components/backTop/index.vue